export default __webpack_public_path__ + "static/image2-1ba0105aec45920728ee188d0143a5ae.jpeg";